import { ref } from 'vue'

const items = ref([])

export default function useLoading() {
  function isLoading(key = null) {
    if ( ! key) {
      return items.value.length > 0
    }

    return items.value.filter(item => item === key).length > 0
  }

  function start(key) {
    items.value = [
      ...items.value.filter(item => item !== key),
      key
    ]
  }

  function stop(key) {
    items.value = items.value.filter(item => item !== key)
  }

  return {
    items,
    isLoading,
    start,
    stop
  }
}
